import moment from "moment";

const colorPalette = ["#3371B7", "#AE9ECC", "#7B86C1", "#DABAF0"];
const monthNames = moment.monthsShort();

export { colorPalette, monthNames };
